<template>
	<div class="checkText">
		<div class="text">
			{{ showText }}
		</div>
	</div>
</template>

<script>
export default {
	name: 'checkText',
	props: ['details'],
	components: {},
	data() {
		return {};
	},
	computed: {
		showText() {
			let { overseasServerFlag, cdnFlag } = this.details;
			if (overseasServerFlag && cdnFlag) {
				return '您的网站采用海外云服务器，并在全球4大节点做了CDN加速服务，不仅可以加快网站的访问速度，让不同地区不同网络环境的用户可以在最短的时间内获得最快的页面加载速度，比单节点服务器可提升了40%的访问速度。';
			}
			if (!overseasServerFlag && cdnFlag) {
				return '您的网站采用国内云服务器，并在全球4大节点做了CDN加速服务，不仅可以加快网站的访问速度，让不同地区不同网络环境的用户可以在最短的时间内获得最快的页面加载速度，比单节点服务器可提升了40%的访问速度。';
			}
			if (overseasServerFlag && !cdnFlag) {
				return '您的网站采用海外云服务器，网站未配置全球CDN加速服务，CDN加速服务支持需要您将域名托管至我司亚马逊云，为保证您的网站在海外的加载体验请尽快跟网建人员对接完成CDN加速服务。';
			}
			if (!overseasServerFlag && !cdnFlag) {
				return '您的网站采用国内云服务器，网站未配置全球CDN加速服务，CDN加速服务支持需要您将域名托管至我司亚马逊云，为保证您的网站在海外的加载体验请尽快跟网建人员对接完成CDN加速服务。';
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.checkText {
	background: #ffffff;
	box-shadow: 0px 4px 4px 0px rgba(67, 93, 255, 0.05);
	margin-bottom: 10px;
  padding: 40px 0px;
	display: flex;
	align-items: center;
	justify-content: center;

	.text {
		width: 60%;
		font-size: 18px;
		font-weight: 500;
		color: #333333;
		line-height: 24px;
	}
}
</style>
